import React from 'react';
import { MONTH_NAMES, daysInMonth, fromJalali, toJalali } from '../utils/jalali';
import { toIsoDate } from '../utils/format';

const fa = (n) => new Intl.NumberFormat('fa-IR', { useGrouping: false }).format(n);

/**
 * انتخاب تاریخ شمسی (روز / ماه / سال). مقدار ورودی و خروجی همان رشته‌ی میلادیِ
 * `YYYY-MM-DD` است که فیلترهای سرور می‌خواهند — شمسی فقط برای چشم کاربر است.
 * `<input type="date">` مرورگر همیشه میلادی است و قابل تنظیم نیست.
 */
export default function JalaliDateInput({ value, onChange, label, id }) {
  const current = value ? toJalali(new Date(`${value}T12:00:00`)) : null;
  const thisYear = toJalali(new Date()).year;
  const years = [];
  for (let y = thisYear + 1; y >= 1403; y -= 1) years.push(y);

  const emit = (year, month, day) => {
    const safeDay = Math.min(day, daysInMonth(year, month));
    onChange(toIsoDate(fromJalali(year, month, safeDay)));
  };

  const set = (part) => (event) => {
    const n = Number(event.target.value);
    const base = current || { year: thisYear, month: 1, day: 1 };
    const next = { ...base, [part]: n };
    emit(next.year, next.month, next.day);
  };

  const dayCount = current ? daysInMonth(current.year, current.month) : 31;

  return (
    <span className="jdate" role="group" aria-label={label}>
      {label && <span className="jdate__label">{label}</span>}
      <select id={id} className="input" value={current?.day ?? ''} onChange={set('day')} aria-label="روز">
        {!current && <option value="">روز</option>}
        {Array.from({ length: dayCount }, (_, i) => i + 1).map((d) => (
          <option key={d} value={d}>{fa(d)}</option>
        ))}
      </select>
      <select className="input" value={current?.month ?? ''} onChange={set('month')} aria-label="ماه">
        {!current && <option value="">ماه</option>}
        {MONTH_NAMES.map((name, i) => (
          <option key={name} value={i + 1}>{name}</option>
        ))}
      </select>
      <select className="input" value={current?.year ?? ''} onChange={set('year')} aria-label="سال">
        {!current && <option value="">سال</option>}
        {years.map((y) => (
          <option key={y} value={y}>{fa(y)}</option>
        ))}
      </select>
      {value && (
        <button type="button" className="link" onClick={() => onChange('')} aria-label="پاک کردن تاریخ">
          ✕
        </button>
      )}
    </span>
  );
}
